<div *ngIf="keycloakUsers.length">
    <p>The following user(s) require import into Barter system.</p>
    <div *ngFor="let user of keycloakUsers">
        {{ user.email }}
    </div>
</div>
